import React from 'react';
import { CoffeeIcon, CreditCardIcon, ShieldCheckIcon, TvIcon, WifiIcon, WrenchIcon } from 'lucide-react';
import { TikTokTips } from './TikTokTips';
const amenities = [{
  icon: WifiIcon,
  title: 'Free guest Wi-Fi',
  copy: 'Work or stream while you wait in the customer lounge.'
}, {
  icon: TvIcon,
  title: 'TV & coffee bar',
  copy: 'A comfortable waiting room with TV and coffee while we work.'
}, {
  icon: WrenchIcon,
  title: 'Modern diagnostic equipment',
  copy: 'Up-to-date, cutting-edge tooling backed by FCA Chrysler, Dodge and Jeep factory training.'
}, {
  icon: ShieldCheckIcon,
  title: '1 year / 12,000 mile warranty',
  copy: 'Parts and labor covered on the repairs we perform.'
}, {
  icon: CreditCardIcon,
  title: 'Financing through Snap',
  copy: 'Ask us about financing options when a repair is larger than expected.'
}, {
  icon: CoffeeIcon,
  title: 'Straight answers, every visit',
  copy: 'You will always know what we found, what it costs, and what can wait.'
}];
export function ShopExperience() {
  return <section id="shop-experience" className="w-full bg-chalk py-20 lg:py-28" data-id="element-182" data-mp="3o6ip3079zrin">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-183" data-mp="3a6q1hdr1prew">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,440px)] lg:items-start lg:gap-16" data-id="element-184" data-mp="3a8awt5l6pedt">
          <div data-id="element-185" data-mp="5rq8vsa5puqq">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-186" data-mp="5rzxbbfjztub">
              The shop
            </p>
            <h2 className="mt-4 max-w-[520px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-187" data-mp="api0el6w3eue">
              A shop built around the customer, not just the car
            </h2>
            <p className="mt-5 max-w-[540px] text-[16.5px] leading-relaxed text-steel/75" data-id="element-188" data-mp="yx3r3as0ke4">
              Over 55 years of combined technician experience, modern equipment
              and a waiting room you will not mind sitting in.
            </p>

            <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2" data-id="element-189" data-mp="13dkr0olnylej">
              {amenities.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-190" data-mp="zcr0rokr0uih">
                  <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-191" data-mp="uccv2d6mdwnm" />
                  <div data-id="element-192" data-mp="pda0jmo9n8tw">
                    <h3 className="font-display text-[16px] font-bold tracking-tight text-ink" data-id="element-193" data-mp="kef61ngxrvty">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-[14px] leading-relaxed text-steel/70" data-id="element-194" data-mp="fmx878a7mbd7">
                      {item.copy}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <TikTokTips data-id="element-195" data-mp="6l7e1uoy0ybq" />
        </div>
      </div>
    </section>;
}